import React, { Component }  from 'react';
import { withRouter }        from 'react-router';
import { connect }           from 'react-redux';
import { Redirect }          from 'react-router-dom';
import TemplateBreadcrumb    from './Breadcrumb';
import UserLanding           from './User/UserLanding';
import AdminLanding          from './Admin/AdminLanding';
import { TemplateConstants } from './environment';
import Required              from '../../Required';
import { isLoggedIn }        from '../../../utils/authService';
import { isInRoleFromToken } from '../../../utils/authService';
import { redirect }          from '../../../utils/authService'; 

class Template extends Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | --Template--';
  }

  render() {
    var path = this.props.location.pathname.toLowerCase();    
    if (!isLoggedIn()) {
      redirect(path.replace(/^\/|\/$/g, ''));
      return (
        <Required />
      );
    }
        
    let content = null;
    if (isInRoleFromToken(TemplateConstants.AdminRole)) {
      let component = null;
      if (path.endsWith(TemplateConstants.PathPrefix)) {
        component = <AdminLanding />;
      }
      else if (path.startsWith(TemplateConstants.AdminPathPrefix)) {
        component = <AdminLanding />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <TemplateBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else if (TemplateConstants.UserRole === "*" || isInRoleFromToken(TemplateConstants.UserRole)) {
      let component = null;
      if (path.endsWith(TemplateConstants.PathPrefix)) {
        component = <UserLanding />;
      }
      else if (path.startsWith(TemplateConstants.UserPathPrefix)) {
        component = <UserLanding />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <TemplateBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else {
      return <Redirect to='/404' />;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({ 
  template: state.template
});

export default withRouter(connect(mapStateToProps)(Template));
